import React from 'react';
import PropTypes from 'prop-types';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Feature from 'marketing-website/components/modules/Feature';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaFeature from 'marketing-website/components/modules/Media/MediaFeature';
import RevealWrapper from 'marketing-website/components/wrappers/RevealWrapper';

import mobileIcon from 'marketing-website/components/icons/Mobile';
import chatIcon from 'marketing-website/components/icons/Chat';
import codeIcon from 'marketing-website/components/icons/Code';

import assets from 'marketing-website/configs/pages/features/prototyping/assets.js';

export default function Stakeholders({ color }) {
  const gridItemProps = {
    align: 'center',
    columnSpan: 12,
    columnSpanM: 12,
    columnSpanS: 4,
  };
  const mediaFeatureProps = {
    ...assets.prototype,
    backgroundColor: color,
    patternBottom: '10%',
    patternLeft: 'auto',
    patternRight: '38%',
    patternTop: 'auto',
  };
  return (
    <Spacing type="margin" size="xl" position="top">
      <RevealWrapper>
        <PageWrap size="l">
          <Spacing type="padding" size="l" sizeM="0" position="bottom">
            <HeadingBlock
              maxWidth={620}
              alignContent="center"
              alignM="center"
              title="Share and present, anywhere"
              copy={
                <span>
                  Fast URL sharing and embed codes for your mockups means you
                  can start getting actionable feedback in no time. Quickly
                  share your web and mobile prototypes with those who matter,
                  whether that's your developers, clients or stakeholders.
                </span>
              }
              justifyContent="center"
              justifyM="center"
              size="l"
            />
          </Spacing>
        </PageWrap>
        <MediaFeature {...mediaFeatureProps}>
          <Grid columns={12} alignContent="space-around">
            <GridItem {...gridItemProps}>
              <MaxWidth value={340}>
                <Feature
                  type="icon"
                  icon={chatIcon}
                  backgroundColor={color}
                  fontWeight="semibold"
                  copy="Create realistic user experiences with our built in interactions for web and mobile devices."
                  title="Add transitions and gestures"
                />
              </MaxWidth>
            </GridItem>
            <GridItem {...gridItemProps}>
              <MaxWidth value={340}>
                <Feature
                  type="icon"
                  icon={mobileIcon}
                  backgroundColor={color}
                  fontWeight="semibold"
                  copy="Prototype for desktop, iPhone, iPad, Apple TV, Apple Watch and Android devices. If it has a screen, Marvel supports it."
                  title="Support for every screen"
                />
              </MaxWidth>
            </GridItem>
            <GridItem {...gridItemProps}>
              <Spacing type="padding" size="l" sizeM="0" position="bottom">
                <MaxWidth value={340}>
                  <Feature
                    type="icon"
                    icon={codeIcon}
                    backgroundColor={color}
                    fontWeight="semibold"
                    copy="Work without worry, present your prototypes without wifi, 3G or any other connectivity."
                    title="Offline downloads"
                  />
                </MaxWidth>
              </Spacing>
            </GridItem>
          </Grid>
        </MediaFeature>
      </RevealWrapper>
    </Spacing>
  );
}

Stakeholders.propTypes = {
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/pages/features/prototyping/Stakeholders.js